module.exports = __webpack_public_path__ + "img/riesgobajo.1249f49d.svg";